import Vuex from "vuex"
import Vue from "vue"
import api from '@/common/api.js'
import bankModel from './bank/index.js'
Vue.use(Vuex)

const userInfo = uni.getStorageSync('userInfo') || {}
const token = uni.getStorageSync('token') || ''
const mallConfig = (uni.getStorageSync('config') && JSON.parse(uni.getStorageSync('config'))) || {}
const globalColor = uni.getStorageSync('textColors') || '#bc0100'
const store = new Vuex.Store({
	state: {
		userInfo,
		token,
		mallConfig,
		globalColor,
		alertCountObj: uni.getStorageSync('alertCountObj'),
	},
	mutations: {
		setAlertCount(state, obj) {
			uni.setStorageSync('alertCountObj', obj)
			state.alertCountObj = obj
		},
		setUserInfo(state, data) {
			state.userInfo = data
			uni.setStorageSync('userInfo', data)
		},
		setToken(state, data) {
			state.token = data
			uni.setStorageSync('token', data)
		},
		setMallConfig(state, data) {
			state.mallConfig = data
			uni.setStorageSync('config', JSON.stringify(data))
		},
		signOut(state){
			state.userInfo = {}
			state.token = ''
			uni.setStorageSync('isToLogin',false);
			uni.removeStorageSync('userInfo')
			uni.removeStorageSync('token')
			// uni.removeStorageSync('pid')
			uni.removeStorageSync('openid')
		},
		setGlobalColor(state, data) { console.log(data,99955);
			state.globalColor = data
			uni.setStorageSync('textColors', data)
		}
	},
	getters: {
		userMsg(state) {
			if(typeof state.userInfo === "string"){
				return JSON.parse(state.userInfo)
			}
			return state.userInfo
		},
		accessToken(state) {
			return state.token
		},
		initConfig(state) {
			return state.mallConfig
		},
		initColor(state) {
			return state.globalColor
		}
	},
	modules: {
		bankModel
	}
})

export default store
